import script from "./AlliesView.vue?vue&type=script&setup=true&lang=js"
export * from "./AlliesView.vue?vue&type=script&setup=true&lang=js"

import "./AlliesView.vue?vue&type=style&index=0&id=f5b0a64a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5b0a64a"]])

export default __exports__